import type { FreeTrialsLeft, FreeTrialStatus } from "@/types/freeTrialsLeft"

const STATUSES: readonly FreeTrialStatus[] = ["unknown", "active", "expired"]

/** The state of a trial from `/users/me/trial`, or null while there is no trial
 *  data. The backend's own `status` wins. Without one (an older backend) the days
 *  decide: null is an unknown clock, 0 is expired, anything else is active. An
 *  unknown clock is never read as expired, or the expired modal and the upgrade
 *  pitch would show to a user whose trial may well be running. */
export function getTrialStatus(
  trial: FreeTrialsLeft["freeTrial"] | null | undefined,
): FreeTrialStatus | null {
  if (!trial) return null
  if (trial.status && STATUSES.includes(trial.status)) return trial.status

  const days = trial.freeTrialDurationLeftDays
  if (typeof days !== "number") return "unknown"
  return days <= 0 ? "expired" : "active"
}
